import { apiService } from './api';
import { ApiResponse, User, LoginCredentials, RegisterData } from '@/types';

class AuthService {
  setToken(token: string | null) {
    apiService.setToken(token);
  }

  async login(credentials: LoginCredentials): Promise<ApiResponse<{ user: User; token: string }>> {
    try {
      return await apiService.post('/auth/login', credentials);
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Login failed'
      };
    }
  }

  async register(data: RegisterData): Promise<ApiResponse<{ message: string }>> {
    try {
      return await apiService.post('/auth/register', data);
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Registration failed'
      };
    }
  }

  async verifyEmail(code: string): Promise<ApiResponse<User>> {
    try {
      return await apiService.post('/auth/verify', { code });
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Verification failed'
      };
    }
  }

  async resendVerification(email: string): Promise<ApiResponse<{ message: string }>> {
    try {
      return await apiService.post('/auth/resend-verification', { email });
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to resend verification'
      };
    }
  }

  async getProfile(): Promise<User> {
    return await apiService.get('/auth/profile');
  }

  async requestPasswordReset(email: string): Promise<ApiResponse<{ message: string }>> {
    try {
      return await apiService.post('/auth/forgot-password', { email });
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to send reset email'
      };
    }
  }

  async resetPassword(token: string, password: string): Promise<ApiResponse<{ message: string }>> {
    try {
      return await apiService.post('/auth/reset-password', { token, password });
    } catch (error: any) {
      return {
        success: false,
        error: error.response?.data?.error || 'Password reset failed'
      };
    }
  }
}

export const authService = new AuthService();